// Exact-action preview row: renders one approval detail. A multiline value
// (the approved email body) is shown verbatim with whitespace-pre-wrap in a
// full-width block so newlines survive on desktop and mobile.
import { Typography } from 'antd';
import { useId, type ReactElement } from 'react';

import type { ApprovalDetail } from './approvalSummary.js';

const { Text } = Typography;

export function ApprovalDetailText({ detail }: { detail: ApprovalDetail }): ReactElement {
  const labelId = useId();

  if (detail.preserveWhitespace === true) {
    return (
      <div className="min-w-0 max-w-full" style={{ fontSize: 12 }}>
        <span id={labelId} className="uppercase tracking-wider">
          {detail.label}:
        </span>
        <div
          aria-labelledby={labelId}
          className="min-w-0 max-w-full break-words whitespace-pre-wrap"
          role="group"
        >
          {detail.value}
        </div>
      </div>
    );
  }
  return (
    <Text className="min-w-0 break-words" type="secondary" style={{ fontSize: 12 }}>
      <span className="uppercase tracking-wider">{detail.label}:</span> {detail.value}
    </Text>
  );
}
